export default __webpack_public_path__ + "static/flyerFront2-28e398a350a3738058120c534cec40d8.jpg";